<template>
  <b-modal
    id="add-transaction-modal"
    title="Add Transaction"
    hide-footer
    centered
  >
    <b-form>
      <!-- Transaction Type -->
      <b-form-group>
        <label for="transactionType">Transaction Type</label>
        <b-form-select
          id="transactionType"
          v-model="form.type"
          :options="optionAddTrans.transactionTypes"
        ></b-form-select>
      </b-form-group>

      <!-- Amount -->
      <b-form-group>
        <label for="amount">Amount</label>
        <b-form-input
          id="amount"
          v-model="form.amount"
          type="number"
          min="0"
          step="0.01"
          placeholder="0.00"
        />
      </b-form-group>

      <!-- Recipient -->
      <b-form-group>
        <label for="recipient">Recipient</label>
        <b-form-input
          id="recipient"
          v-model="form.recipient"
          placeholder="Recipient name"
        />
      </b-form-group>

      <!-- External Ref -->
      <b-form-group>
        <label for="externalRef">External Ref</label>
        <b-form-input
          id="externalRef"
          v-model="form.externalRef"
          placeholder="Enter external reference..."
        />
      </b-form-group>

      <!-- Processor Name -->
      <b-form-group>
        <label for="processor">Processor Name</label>
        <b-form-select
          id="processor"
          v-model="form.processor"
          :options="optionAddTrans.processors"
        ></b-form-select>
      </b-form-group>

      <!-- Processed By -->
      <b-form-group>
        <label for="processedBy">Processed By</label>
        <b-form-select
          id="processedBy"
          v-model="form.processedBy"
          :options="optionAddTrans.processedByOptions"
        ></b-form-select>
      </b-form-group>

      <!-- Notes -->
      <b-form-group>
        <label for="notes">Notes</label>
        <b-form-textarea
          id="notes"
          v-model="form.notes"
          placeholder="Enter notes..."
          rows="3"
        />
      </b-form-group>

      <!-- Buttons -->
      <div class="d-flex justify-content-end">
        <b-button
          variant="secondary"
          @click="$bvModal.hide('add-transaction-modal')"
        >
          Cancel
        </b-button>
        <b-button variant="success" type="submit" class="ml-2"> Save </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BButton,
  BCol,
  BFormInput,
  BFormSelect,
  BRow,
  BModal,
  BFormGroup,
  BFormTextarea,
} from "bootstrap-vue";

export default {
  components: {
    BButton,
    BFormInput,
    BFormSelect,
    BRow,
    BCol,
    BModal,
    BFormGroup,
    BFormTextarea,
  },
  data() {
    return {
      form: {
        type: "Deposit",
        amount: 0.0,
        recipient: "",
        externalRef: "",
        processor: "StakeToken",
        processedBy: "System",
        notes: "",
      },
      optionAddTrans: {
        transactionTypes: [
          "Deposit",
          "Withdrawal",
          "Refund",
          "Adjustment",
          "Fee",
          "Bet Pending",
          "Bet Resulted",
          "Bet Win",
          "Bet Loss",
          "Bonus Issued",
          "Free Bet Granted",
          "Promotion Redemption",
          "Money Back Special",
        ],
        processors: ["StakeToken", "Stripe", "Adyen", "Bank"],
        processedByOptions: ["System", "Admin User", "Payments Bot"],
      },
    };
  },
  computed: {},
  methods: {},
};
</script>
